import React, { Component } from 'react';
import './Table.css';
import Utils from '../../../base/Utils';

class Table extends Component {
    render() {
        var data = Utils.checkUsage(this.props.data);
        
        return <table className="Table">
        {
            (Utils.checkArray(data.head)) ? <thead><tr>{
                data.head.map(function(td, tdKey){
                    var align = td.align || 'center';
                    
                    return <td key={tdKey} style={{textAlign:align}}>{td.content}</td>;
                })
            }</tr></thead> : ''
        }{
            (Utils.checkArray(data.body)) ? <tbody>{
                data.body.map(function(tr, trKey){
                    return <tr key={trKey}>{
                        tr.map(function(td, tdKey){
                            var align = td.align || 'center';
                            
                            return <td key={trKey + '-' + tdKey} style={{textAlign:align}}>{td.content}</td>;
                        })
                    }</tr>;
                })
            }</tbody> : ''
        }
        </table>;
    }
}

export default Table;
